<gpf-markdown-editor
  *ngIf="aboutDescription"
  (writeEvent)="writeDescription($event)"
  [initialMarkdown]="aboutDescription"></gpf-markdown-editor>
